export function safeNumber(num?: number | null, decimalRoundOff?: number) {
  if (!num) return 0;

  const d = decimalRoundOff ?? 2;

  return Math.round(num * Math.pow(10, d)) / Math.pow(10, d);
}
